export default "__VITE_ASSET__CmnCb5PV__"